import { getMonoid as getMonoidArray, map } from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { fold, struct } from 'fp-ts/Monoid';
import { getMonoid as getMonoidRecord } from 'fp-ts/Record';
import { last } from 'fp-ts/Semigroup';
import lodash from 'lodash';

import type { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type {
  NodeViewDecorator,
  NodeViewRenderer,
  PluginTypeMapper,
  ViewerPlugin,
} from './../ricos-types';

import type { ContentViewerProps, RCVPluginProps } from './types';

const recordMergeM = <T>() => getMonoidRecord<string, T>(last<T>());
const nodeViewRenderersMergeM = () => getMonoidRecord<Node_Type, NodeViewRenderer>(last());
const rcvPropM = struct<RCVPluginProps>({
  config: recordMergeM<any>(),
  typeMappers: getMonoidArray<PluginTypeMapper>(),
  nodeViewDecorators: getMonoidArray<NodeViewDecorator<JSX.Element>>(),
  // @ts-ignore $TSFixMe
  nodeViewRenderers: nodeViewRenderersMergeM(),
});
const extractChildRCVPluginProps = ({
  config = {},
  typeMappers = [],
  nodeViewRenderers,
  nodeViewDecorators,
}: any): RCVPluginProps => ({
  config,
  typeMappers,
  nodeViewRenderers,
  nodeViewDecorators,
});

const toRCVPluginProps =
  () =>
  (plugin: ViewerPlugin): RCVPluginProps => {
    const pluginProps: RCVPluginProps = {
      config: { [plugin.type]: plugin.config },
      typeMappers: [],
      nodeViewRenderers: {},
      nodeViewDecorators: [],
    };

    if (plugin.nodeViewRenderers) {
      pluginProps.nodeViewRenderers = plugin.nodeViewRenderers;
    } else if (plugin.typeMapper) {
      pluginProps.typeMappers = [plugin.typeMapper];
    }

    pluginProps.nodeViewDecorators = plugin.nodeViewDecorators ? plugin.nodeViewDecorators : [];

    return pluginProps;
  };

const mergeWithChildProps = (childPluginProps: $TSFixMe) => (pluginProps: $TSFixMe) =>
  lodash.merge({}, pluginProps, childPluginProps);

export default function pluginsStrategy({
  plugins = [],
  viewerProps,
}: {
  plugins: ViewerPlugin[];
  viewerProps: Partial<ContentViewerProps>;
}): RCVPluginProps {
  return pipe(
    plugins as ViewerPlugin[],
    map(toRCVPluginProps()),
    fold(rcvPropM),
    mergeWithChildProps(extractChildRCVPluginProps(viewerProps))
  );
}
